import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'itemsFilter',
    standalone: false
})
export class ItemsFilterPipe implements PipeTransform {

  transform(items: any, filter: string): any {
    if (!filter || filter === '') {
      return items;
    }
    return items.filter((item) => item.value.name.toLowerCase().includes(filter.toLowerCase()));
  }
}
